<template>
  <div class="stat-panel h-100">
    <div class="stat-panel-head">
      <div>
        <h5>پرفروش‌ترین‌ها</h5>
        <p class="text-muted mb-0 small">محصولاتی با بیشترین تعداد فروش</p>
      </div>
      <i class="bi bi-trophy text-primary"></i>
    </div>

    <div v-if="topSellProducts.length" class="table-responsive">
      <table class="stat-table text-center">
        <thead>
        <tr>
          <th width="48">رتبه</th>
          <th class="text-right">نام محصول</th>
          <th>تعداد فروش</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in topSellProducts" :key="item.id || index">
          <td>
            <span class="stat-rank" :class="{'is-top': index === 0}">{{ index + 1 }}</span>
          </td>
          <td class="stat-product-name">{{ item.name }}</td>
          <td>
            <span class="stat-pill is-sales">{{ formatNumber(item.order_count) }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="stat-empty">
      <i class="bi bi-bag"></i>
      <p class="mb-0">محصول پرفروشی یافت نشد.</p>
    </div>

    <div v-if="!compact" class="stat-pager text-center">
      <pagination class="mx-auto" :meta="pagination" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "../../dashboard/Pagination.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "StatisticTopSellProduct",
  components: {Pagination},
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        page: 1,
        per_page: this.compact ? 5 : 15,
      },
      pagination: [],
      topSellProducts: [],
    }
  },
  methods: {
    formatNumber,
    getTopSellProducts(form) {
      this.$store.dispatch('Statistic/topSellProducts', form).then(res => {
        let baseData = res.data.data;
        this.topSellProducts = this.compact
          ? (baseData.data || []).slice(0, 5)
          : baseData.data
        this.pagination = baseData.meta
      });
    },
    changePage(page) {
      this.form.page = page
      this.getTopSellProducts(this.form)
    },
  },
  mounted() {
    this.getTopSellProducts(this.form)
  }
}
</script>
